
import _ from 'lodash';
import { createResponse } from '../altFunctions/common';
import { createResponseTypes } from '../cnr/reducers/CreateReducer';

const regGenericTypes = {
  regGeneric: 'regGeneric',
}

const regFunctionTypes = {
  createEventFromFetch: 'createEventFromFetch',
  getRegData: 'getRegData',
};
/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(regGenericTypes.regGeneric, callData)
  return data
}
// 67BC9D2B644B6
export const fsfn_allReg = (fsCall) => {
  return {
    createEventFromFetch: (urlData) => fsfn_createEventFromFetch(fsCall, urlData),
    getRegData: (clientKey, eventKey, createEvent, showToken) => fsfn_getRegData(fsCall, clientKey, eventKey, createEvent, showToken),
  }
}

const fsfn_getRegData = async (fsCall, clientKey, eventKey, createEvent, showToken) => {
  const callData = {
    clientKey,
    eventKey,
    fetchFunctionType: regFunctionTypes.getRegData,
    showToken,
    createEvent,
    //9BEC61EC5746BFD85CE5
    // cHJvYkgNpMx8Lov7nq5UC2xEOvitdNEmOgaId6aaSStuvNrVf7lKhPiEe9fO7g53
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK   
    // DEMO
    return response_data
  } catch (error) {
    console.error('fsfn_getRegData - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

const fsfn_createEventFromFetch = async (fsCall, urlData) => {
  // console.log('response', response)
  // urlData.options = {
  //   "menthod": "GET",
  //   "rejectUnauthorized": false,
  //   "credentials": "include",
  //   headers: { "Content-Type": "application/json" }
  // }   
  urlData.ignoreSLL = true
  const callData = {
    urlData,
    fetchFunctionType: regFunctionTypes.createEventFromFetch
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error('fsfn_createEventFromFetch - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

